module.exports = __webpack_public_path__ + "assets/img/bbsbook.6e4ba864.svg";